module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sample-license-dialog px-5 pt-5 pb-3"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "my-dialog__footer"
  }, [_c('v-btn', {
    attrs: {
      "color": "blue",
      "dark": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_vm._v("Ok")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-dialog__header"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "ml-3"
  }, [_vm._v("Sample Clearance License")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-dialog__content"
  }, [_c('div', {
    staticClass: "my-dialog__content__section border-bottom py-4"
  }, [_c('p', [_vm._v("\n        YouSound Sample Clearance License allows Verified Artists to give\n        other Verified Artists permission to sample or mix music submitted to\n        YouSound by copyright owners for executive broadcast on YouSound. Any\n        song that is sampled is credited in Album Credits, which gives\n        listeners one click discovery of album collaborator & contributor\n        profiles.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        Read the license here\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "my-dialog__content__section pt-4"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("You can:")]), _vm._v(" "), _c('h6', [_vm._v("Legally sample / mix cleared songs and upload them to YouSound")]), _vm._v(" "), _c('h6', [_vm._v("Promote artists you sample by crediting artists")])]), _vm._v(" "), _c('div', {
    staticClass: "my-dialog__content__section border-bottom py-4"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("You cannot:")]), _vm._v(" "), _c('h6', [_vm._v("\n        Sample content from YouSound and distribute sampled content outside of\n        YouSound\n      ")]), _vm._v(" "), _c('h6', [_vm._v("\n        Sample content from YouSound and sell physical copies of sampled\n        content\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ff1878d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/album/components/sample_license_dialog.vue
// module id = 1741
// module chunks = 180